import { Col, Dropdown, Menu, Row, Tooltip } from "antd";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";
import ModalComponent from "../../../biblio/Modal/ModalComponent";
import PrimaryButton from "../../../biblio/Buttons/PrimaryButton";
import PdfPreview from "../../../biblio/Modal/PdfPreview";
import { getSponsorThanksCertificate } from "../../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../../apis/store";
import { useDispatch, useSelector } from "react-redux";
import type { MenuProps as Props } from "antd";
import { isRoleSponsor } from "../sponsor/orphans/utils";
import { setEditMode } from "../../../apis/slices/recipientSlice";

interface MenuProps {
  role: "beneficiary" | "sponsor";
  className?: string;
  isExpanded: boolean;
  sponsor?: any;
  selectedItemMenu?: string;
  setIsExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
  setSelectedItemMenu?: React.Dispatch<React.SetStateAction<any | null>>;
  menu: any;
  handleMenuClickBurger?: (key: string) => void;
  profileName?: string;
  isFromBurger?: boolean;
}
const MenuProfile = ({
  setIsExpanded,
  profileName,
  setSelectedItemMenu,
  handleMenuClickBurger,
  isExpanded,
  selectedItemMenu,
  role,
  sponsor,
  menu,
  isFromBurger,
  ...props
}: MenuProps) => {
  const dispatch = useDispatch<AppDispatch>();
  const [expandedParentKey, setExpandedParentKey] = useState<string | null>(
    null
  );
  const { certificateThanks } = useSelector(
    (state: RootState) => state.sponsor
  );
  const otpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const file =
    certificateThanks != null
      ? new Blob([certificateThanks], { type: "application/pdf" })
      : null;

  const url = file ? URL.createObjectURL(file) : undefined;

  const [selectedKey, setSelectedKey] = useState(
    selectedItemMenu ? selectedItemMenu : role === "beneficiary" ? "b1" : "s1"
  );
  useEffect(() => {
    setSelectedKey(selectedItemMenu ? selectedItemMenu : selectedKey);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItemMenu]);

  const handleMenuClick = (e: any) => {
    const excludedKeys = [
      "b9",
      "s13",
      "s11",
      "b",
      "s",
      "nb",
      "nb1",
      "ns1",
      "ns2",
      "nb4",
      "nb3",
    ];

    if (!excludedKeys.includes(e.key)) {
      setSelectedKey(e.key);
      navigate("/profile", { state: { selectedKey: e.key } });
    }

    handleMenuLogout(e.key);
  };

  const navigate = useNavigate();
  const [cookies, , removeCookie] = useCookies(["apiKey", "role"]);
  useEffect(() => {
    if (!cookies || !cookies.apiKey) {
      localStorage.removeItem("OtpId");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookies?.apiKey]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalPdfVisible, setIsModalPdfVisible] = useState(false);

  const handleLogout = () => {
    removeCookie("apiKey", { path: "/" });
    removeCookie("role", { path: "/" });
    localStorage.removeItem("OtpId");
    navigate("/");
  };
  const [isVisible, setIsVisible] = useState(window.innerWidth < 900);
  useEffect(() => {
    const handleResize = () => setIsVisible(window.innerWidth < 900);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [isSubmenuVisible, setIsSubmenuVisible] = useState(false);
  const handleMenuLogout = (key: string) => {
    if (isVisible && (key === "b9" || key === "s13")) {
      setIsSubmenuVisible(!isSubmenuVisible);
    } else if (key === "b9" || key === "s13") {
      setIsModalVisible(true);
    } else if (key === "s11") {
      dispatch(getSponsorThanksCertificate(otpId));

      setIsModalPdfVisible(true);
    } else {
      setIsSubmenuVisible(false);
      setSelectedItemMenu && setSelectedItemMenu(key);
    }
  };

  const confirmLogout = () => {
    handleLogout();
    setIsModalVisible(false);
  };

  const cancelLogout = () => {
    setIsModalVisible(false);
  };

  const items: Props["items"] = [
    {
      key: "1",
      label: (
        <p
          className="takaful--item-dropdown"
          onClick={() =>
            navigate("/profile", {
              state: {
                selectedKey:
                  role !== "beneficiary"
                    ? "s4"
                    : (() => {
                        dispatch(setEditMode(true));
                        return "b1";
                      })(),
              },
            })
          }
        >
          تعديل الملف
        </p>
      ),
    },
    {
      key: "2",
      label: (
        <p
          className="takaful--item-dropdown"
          onClick={() => setIsModalVisible(true)}
        >
          تسجيل الخروج
        </p>
      ),
    },
  ];
  const handleParentClick = (key: string) => {
    setExpandedParentKey((prevKey) => (prevKey === key ? null : key));
  };
  return (
    <>
      <Menu
        {...props}
        onClick={handleMenuClick}
        selectedKeys={[selectedKey]}
        mode="vertical"
        className={`custom-menu
        ${isRoleSponsor(role) ? "custom-menu-sponsor" : ""} ${
          props.className ? props.className : ""
        }`}
        style={{
          position: "relative",
        }}
      >
        {menu
          ?.filter((item: any) => item?.disabled !== false)
          ?.map((item: any) => (
            <React.Fragment key={item.key}>
              <Menu.Item
                key={item.key}
                className={`${isExpanded ? "" : "expanded"}`}
                icon={
                  !isExpanded ? (
                    <Tooltip
                      overlayClassName="takaful--share-tooltip"
                      placement="leftTop"
                      title={item.title}
                    >
                      <img src={item.icon} alt={item.title} />
                    </Tooltip>
                  ) : (
                    <img src={item.icon} alt={item.title} />
                  )
                }
                onClick={(e) => {
                  handleParentClick(item.key);
                  handleMenuClickBurger && handleMenuClickBurger(item.key);
                  handleMenuLogout(item.key);
                }}
              >
                {isVisible ? (
                  item?.key === "b9" || item?.key === "s13" ? (
                    <Dropdown
                      menu={{ items }}
                      placement="bottom"
                      overlayStyle={{ direction: "rtl" }}
                    >
                      <span style={{ color: "#1caca5", fontWeight: "bold" }}>
                        {profileName}
                      </span>
                    </Dropdown>
                  ) : (
                    item.title
                  )
                ) : (
                  item?.title
                )}
              </Menu.Item>

              {item.children &&
                expandedParentKey === item.key &&
                item.children
                  ?.filter((item: any) => item?.disabled !== false)
                  .map((subItem: any) => (
                    <Menu.Item
                      key={subItem.key}
                      className={`${isExpanded ? "" : "expanded"} submenuItem`}
                      style={{
                        paddingRight: isExpanded ? 60 : 2,
                      }}
                      onClick={(e) => handleMenuClick(subItem)}
                      icon={
                        !isExpanded ? (
                          <Tooltip
                            overlayClassName="takaful--share-tooltip"
                            placement="leftTop"
                            title={subItem.title}
                          >
                            <img src={subItem.icon} alt={subItem.title} />
                          </Tooltip>
                        ) : null
                      }
                    >
                      {subItem.title}
                    </Menu.Item>
                  ))}
            </React.Fragment>
          ))}
      </Menu>
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={cancelLogout}
        closeOnOutsideClick={true}
        centered={true}
      >
        <Row justify={"center"}>
          <p className="takaful--confirm-logout">
            هل أنت متأكد أنك تريد تسجيل الخروج؟
          </p>
        </Row>
        <Row gutter={16} justify={"center"} style={{ paddingTop: "2rem" }}>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--cancel-btn-logout"
              title="لا"
              onClick={cancelLogout}
            />
          </Col>
          <Col xxl={6} xl={6} lg={6} md={6} sm={9} xs={9}>
            <PrimaryButton
              className="takaful--confirm-btn-logout"
              title="نعم"
              onClick={confirmLogout}
            />
          </Col>
        </Row>
      </ModalComponent>

      <PdfPreview
        open={isModalPdfVisible}
        onClose={() => setIsModalPdfVisible(false)}
        url={url}
        isBlob={true}
        className="takaful--pdf-preview-modal"
      />
    </>
  );
};

export default MenuProfile;
